<template>
<div class="footer" v-if="is_not_domains_search">
  <ul v-for="section in sections">
    <li v-if="!section.multiRow" class="section-heading">
      {{$t(`footer.${section.name}`)}}
    </li>
    <li v-for="link in section.links">
      <brave-link :to="link.href">
        {{$t(`${section.name.toLowerCase()}.${link.name}_TITLE`)}}
      </brave-link>
    </li>

    <template v-if="section.multiRow" v-for="row in section.rows" class="section-heading">
      <li :class="row.class" class="section-heading">{{$t(`footer.${row.name}`)}}</li>
      <li v-for="link in row.links">
        <a v-if="link.external == true" :href="link.href">{{$t(`${row.name.toLowerCase()}.${link.name}_TITLE`)}}</a>
        <brave-link v-else :to="link.href">{{$t(`${row.name.toLowerCase()}.${link.name}_TITLE`)}}</brave-link>
      </li>
    </template>
  </ul>
  <div class="">
    <div class="footer-logo">
      <img src="../assets/img/shared/bravenet-footer-logo.png" alt="Bravenet.com" title="" style="">
    </div>
    <div v-html="$t('footer.FOOTER_COMPANY_DESCRIPTION')"/>
    <p>&copy; {{new Date().getFullYear()}} Bravenet Web Services Inc.</p>
    <p>
       <a href="https://www.facebook.com/bravenetwebservices/"><img class="social-icons" src="../assets/img/shared/footer-facebook.png" alt="Facebook"></a>
       <a href="https://x.com/bravenet"><img class="social-icons" src="../assets/img/shared/footer-x.png" alt="Twitter"></a>
    </p>
  </div>
</div>
</template>
<script>
import {FOOTER_NAV_LINKS} from 'app-constants'
import style from 'styles/shared-footer.scss'
export default {

  data() {
    let sections = FOOTER_NAV_LINKS;
    let is_not_domains_search = (this.$route.path.match('domains_search')) ? false:true;
    return {
      sections,
      is_not_domains_search
    }
  }
}
</script>


// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/shared-footer.vue